import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Card } from 'components/@shared/Card';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { PATH } from 'routes/path';
import { useDidMount } from 'hooks/useDidMount';
import { ProposalForm } from 'components/Proposals/ProposalForm';
import { getProposalFormData, updateProposal } from 'services/proposalService';
import { ProposalFormData } from 'types/proposal';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const EditProposalPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [initialData, setInitialData] = useState<ProposalFormData | null>(null);

    const notifications = useNotifications();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const submitHandler = (form: ProposalFormData) => {
        setIsLoading(true);
        if (id) {
            updateProposal(id, form)
                .then(() => {
                    notifications.show({ message: 'Proposal successfully updated' });
                    navigate(PATH.PROPOSALS);
                })
                .finally(() => setIsLoading(false));
        }
    };

    useDidMount(() => {
        if (id) {
            getProposalFormData(id)
                .then(setInitialData)
                .finally(() => setIsLoading(false));
        }
    });

    if (isLoading) {
        return <BackdropLoader />;
    }

    if (!initialData) {
        return <Typography>No data</Typography>;
    }

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Proposal" sx={cardStyles}>
                <ProposalForm initialData={initialData} onSubmit={submitHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
